module.exports = new __parcel__URL__("landfill.465d154f.jpg").toString();